module.exports = __webpack_public_path__ + "img/av_otter.e251be0c.png";